import React from 'react';
import { PropTypes } from 'prop-types';
import { Button } from 'sarsaparilla';

const propTypes = {
  onStart: PropTypes.func,
  permit: PropTypes.object.isRequired
};

const defaultProps = {};

export default class QuestionnaireStart extends React.Component {

  constructor(props) {
    super(props);
    this.onStart = this.onStart.bind(this);
  }

  onStart(e) {
    e.preventDefault();
    this.props.onStart();
  }

  render() {
    return (
      <div className="rec-questionnaire-intro">
        <h1 className="rec-questionnaire-title">Which Permit Do I Need?</h1>
        <p className="rec-questionnaire-subheader">For {this.props.permit.name}</p>
        <p className="rec-questionnaire-content">Answer the questions on the following pages to find the best permit you need to reserve for your trip.</p>
        <Button
          className="rec-button-primary"
          title="start button"
          onClick={this.onStart}
          aria-label="start button">
          Let&apos;s Begin
        </Button>
      </div>
    );
  }

}

QuestionnaireStart.displayName = 'QuestionnaireStart';
QuestionnaireStart.propTypes = propTypes;
QuestionnaireStart.defaultProps = defaultProps;
